import { gql } from "@apollo/client";

export const createContributorMutation = gql`
    mutation createContributor($data: ContributorCreateInput!) {
        createContributor(data: $data) {
            id
        }
    }
`;

export const deleteContributorMutation = gql`
    mutation deleteContributor($where: ContributorWhereUniqueInput!) {
        deleteOneContributor(where: $where) {
            id
        }
    }
`;

export const upsertRoleMappingMutation = gql`
    mutation upsertRoleMapping($clientId: Int!, $mappedName: String!, $roleId: Int!) {
        upsertRoleMapping(clientId: $clientId, mappedName: $mappedName, roleId: $roleId) {
            mappedName
            roleId
            roleName
        }
    }
`;

export const editContributorMutation = gql`
    mutation updateContributor($data: ContributorUpdateInput!, $where: ContributorWhereUniqueInput!) {
        updateOneContributor(data: $data, where: $where) {
            id
        }
    }
`;
